import { useState } from 'react';

const Cookie = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

return (
    <div className="fixed bottom-20 left-1/2 z-50 -translate-x-1/2 rounded-full bg-white p-2 shadow-2xl max-sm:w-11/12">
        <div className="flex items-center justify-between gap-6 text-[12px]">
            <div className="pl-4">
                Este site utiliza cookies para melhorar sua experiência na web.
            </div>
            <div className="text-end">
                <button onClick={() => setIsVisible(false)} className="cursor-pointer rounded-full bg-black px-4 py-2 text-white">Aceitar</button>
            </div>
        </div>
    </div>
);
};

export default Cookie;